import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["results"];
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import ExecutionResult from 'automation-ui-log-events/records/ExecutionResult/ExecutionResult';
import AssociatedExecutionStates from 'automation-ui-log-events/records/ExecutionResult/AssociatedExecutionStates';
export const getAssociatedExecutionResults = ({
  enrollmentId,
  actionExecutionIndex,
  executionState,
  nextPage,
  limit = 10
}) => {
  const params = {
    enrollmentId,
    actionExecutionIndex,
    limit,
    executionState
  };
  if (nextPage) {
    params.after = nextPage;
  }
  return http.get('automationplatform/v1/history/associated-execution-results', {
    query: params
  });
};
const executionResultsFetcherFactory = executionState => ({
  actionExecutionIndex,
  enrollmentId,
  limit,
  nextPage
}) => getAssociatedExecutionResults({
  actionExecutionIndex,
  enrollmentId,
  executionState,
  limit,
  nextPage
}).then(_ref => {
  let {
      results
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Object.assign({
    results: results.map(result => {
      return new ExecutionResult(result);
    })
  }, rest);
});
const successfulExecutionResultsFetcher = executionResultsFetcherFactory(AssociatedExecutionStates.SUCCESS);
const failedExecutionResultsFetcher = executionResultsFetcherFactory(AssociatedExecutionStates.FAILURE);
export const SUCCESSFUL_EXECUTION_RESULTS_FIELDNAME = 'successfulExecutionResults';
export const GET_SUCCESSFUL_ASSOCIATED_EXECUTION_RESULTS = registerQuery({
  fieldName: SUCCESSFUL_EXECUTION_RESULTS_FIELDNAME,
  args: ['actionExecutionIndex', 'enrollmentId', 'limit', 'nextPage'],
  fetcher: ({
    actionExecutionIndex,
    enrollmentId,
    limit,
    nextPage
  }) => successfulExecutionResultsFetcher({
    actionExecutionIndex,
    enrollmentId,
    limit,
    nextPage
  })
});
export const FAILED_EXECUTION_RESULTS_FIELDNAME = 'failedExecutionResults';
export const GET_FAILED_ASSOCIATED_EXECUTION_RESULTS = registerQuery({
  fieldName: FAILED_EXECUTION_RESULTS_FIELDNAME,
  args: ['actionExecutionIndex', 'enrollmentId', 'limit', 'nextPage'],
  fetcher: ({
    actionExecutionIndex,
    enrollmentId,
    limit,
    nextPage
  }) => failedExecutionResultsFetcher({
    actionExecutionIndex,
    enrollmentId,
    limit,
    nextPage
  })
});